import React, { useEffect, useState } from "react";
import { Clock, ChevronDown } from "lucide-react";
import api from "@/lib/api";

const fmt = (s) => (s >= 3600 ? `${Math.floor(s / 3600)}h ${Math.round((s % 3600) / 60)}m` : `${Math.max(1, Math.round(s / 60))}m`);

const StudentRow = ({ s }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="rounded-lg bg-white/[0.03] border border-white/10" data-testid={`progress-student-${s.id}`}>
      <button onClick={() => setOpen((o) => !o)} className="w-full flex items-center justify-between px-3 py-2.5 text-left" data-testid={`progress-toggle-${s.id}`}>
        <span className="text-sm truncate">{s.name}</span>
        <span className="flex items-center gap-2 shrink-0 font-tab text-xs">
          <span className={s.total_seconds ? "cyan-text" : "text-slate-600"}>{s.total_seconds ? fmt(s.total_seconds) : "not yet"}</span>
          {s.tabs.length > 0 && <ChevronDown className={`w-3.5 h-3.5 text-slate-500 transition-transform ${open ? "rotate-180" : ""}`} />}
        </span>
      </button>
      {open && s.tabs.length > 0 && (
        <div className="px-3 pb-2.5 space-y-1">
          {s.tabs.map((t) => (
            <div key={`${t.title}-${t.artist}`} className="flex items-center justify-between text-xs text-slate-400">
              <span className="truncate">{t.title}{t.artist ? ` — ${t.artist}` : ""}</span>
              <span className="font-tab shrink-0 ml-2">{fmt(t.seconds)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export const StudentProgress = ({ open }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    if (!open) return;
    api.get("/team/progress").then((r) => setRows(r.data.students)).catch(() => setRows([]));
  }, [open]);
  if (!rows.length) return null;
  return (
    <div className="mb-6" data-testid="student-progress">
      <h4 className="font-heading text-sm uppercase tracking-widest text-[#00f0ff] mb-2 flex items-center gap-2">
        <Clock className="w-4 h-4" /> Practice this week
      </h4>
      <div className="space-y-1.5">{rows.map((s) => <StudentRow key={s.id} s={s} />)}</div>
      <p className="text-[11px] text-slate-600 mt-2">Time spent playing each tab since Monday. Tap a student to see songs.</p>
    </div>
  );
};
